import { useLocale, useTranslation } from '@aviv-unified-frontend/runtime/i18n';
import { useMemo, useRef } from 'react';
import type { Translations } from '@aviv-unified-frontend/runtime/i18n';

export const NAME_SPACE = 'mfe_esfu_brand';

/**
 * Hook to load the translations for the current brand and locale.
 */
export const useLoadTranslations = (namespace: typeof NAME_SPACE) => {
    const { language } = useLocale();
    const { addTranslations } = useTranslation(namespace);
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const removeTranslations = useRef(() => {});

    removeTranslations.current = useMemo(() => {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        removeTranslations.current?.();

        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const translations: Translations = require(`../translations/${language}.json`);

        return addTranslations({
            language,
            translations,
        });
    }, [addTranslations, language]);
};
